import { useCustomer } from '@/src/context/customer/customer-context'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { jwtDecode } from 'jwt-decode'
import { signIn } from 'next-auth/react'
import { useSearchParams } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import LoadingFullscreen from '../../loadings/loading-fullscreen/loading-fullscreen'
import { LocalStorageNames } from '@/src/constants/localstorage-names'
import { CustomerService } from '@/src/services/merchant/customer-service'
import PathHelper from '@/src/helpers/path-helper'

export default function CheckSocialLogin() {
    const { setCustomer } = useCustomer()
    const { merchantSummary } = useMerchant()
    const searchParams = useSearchParams()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const accessToken = searchParams.get('accessToken')
        const refreshToken = searchParams.get('refreshToken')

        const signSocialUser = async () => {
            try {
                if (accessToken && searchParams) {
                    localStorage.setItem(LocalStorageNames.LoggingSocial, 'true')

                    PathHelper.clearQueryParams()

                    setIsLoading(true)

                    const decoded = jwtDecode(accessToken) as any

                    if (!decoded?.sub)
                        throw Error("Não foi possível obter o código do usuário.")

                    const customerResponse = await CustomerService.getCustomer(decoded.sub, accessToken)

                    if (!customerResponse.success || !customerResponse.model)
                        throw Error(customerResponse.errorMessage)

                    const merchantId = decoded.MerchantId
                    const email = decoded.email
                    const password = Date.now()
                    const accessTokenExpiresIn = decoded.exp

                    const result = await signIn('credentials', {
                        redirect: false,
                        email,
                        password,
                        merchantId,
                        accessToken,
                        refreshToken,
                        accessTokenExpiresIn
                    })

                    if (result?.error)
                        throw Error(result?.error)

                    const source = decoded.AuthSource.toLowerCase() === 'google' ? 'Google' : 'Facebook'

                    setCustomer({
                        ...customerResponse.model,
                        authSource: source
                    })
                }
            }
            catch (e) {
                console.error(e)
            }
            finally {
                setIsLoading(false)
                localStorage.removeItem(LocalStorageNames.LoggingSocial)
            }
        }

        if (merchantSummary)
            signSocialUser()
    }, [merchantSummary])

    return (
        <>
            {isLoading && <LoadingFullscreen />}
        </>
    )
}
